import { Injectable } from '@angular/core';
import { Router, CanActivate,ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Subscription } from 'rxjs';
import { GlobalEventMangerService } from './global-event-manger.service';

import { LocalstorageService } from './localstorage.service';
import { UserService } from './user.service';
import {map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
    public userStatus_id :string;
    public ghostLogin : boolean=false;
    public menuPermissionVal :{};
    public userRole : string;
    busy: Subscription;
    public token: string;
	public user_id: string;
    public merchant_id: string;

    constructor(private router: Router, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService, protected userService:UserService) { }
   
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {        
        let currentToken = <any>{};
        let userDetails = <any>{};
        let menuPermission = <any>{};
        var currentUser = this.localStorageService.getData("currentUserToken");
        var super_admin_token = this.localStorageService.getData("super_admin_token");

        this.globalEventMangerService.ghostLoginEmitter.subscribe((mode)=>{
            this.ghostLogin = mode;
        });
        
        userDetails = this.localStorageService.getData("currentUser");
        if (userDetails) {
            this.userRole = userDetails.role_id;
            this.user_id = userDetails._id;
            this.merchant_id = userDetails.merchant_token;
            this.token =  currentUser.data.user_token;
            if(this.userRole == '3' || this.userRole == '4') {
                menuPermission = userDetails.settings;
                this.menuPermissionVal = menuPermission.permissions;
                currentToken = this.localStorageService.getData("currentUserToken");
                let url = state.url;
                let repStr = url.replace('/','')
				let urlStr = repStr.split("/")[0];
                if((currentToken && !currentToken.data.is_steps_completed  && !this.ghostLogin && this.userRole == '3' && url != '/get-started-deposits' && url != '/get-started-plan')) {
                    if(super_admin_token && super_admin_token.data.role_name !== 'super_admin') {
                        this.router.navigate(['/dashboard']);
                        return false;
                    } else {
                        this.router.navigate(['/get-started-deposits']);
                        return false;
                    }
                } else {
                    if(url != '/get-started-deposits' && url != '/get-started-plan') {
                        let model: any = {};
                        model.user_token = this.token;
                        model.user_id =  this.user_id;
                        model.merchant_id =  this.merchant_id;
                        model.url =  urlStr;

                        return this.userService.checkUrlPermission(model).pipe(
                            map(user => {
                            if(user) {
                                return true;
                            } else {
                                this.router.navigate(['/page-not-found']);
                                return false;
                            }
                            }),
                            tap({
                            error: error => { 
                                this.router.navigate(['/page-not-found']);
                                return false;
                            }
                            })
                        );
                    } else if (currentToken && currentToken.data.is_steps_completed && !this.ghostLogin && this.userRole == '3' && (url == '/get-started-deposits' || url == '/get-started-plan')) {
                        this.router.navigate(['/dashboard']);
                        return false;
                    } else {
                        var super_admin_token = this.localStorageService.getData("super_admin_token");
                        this.userRole = userDetails.role_id;
                        if((super_admin_token && this.userRole == '1' && super_admin_token.data.role_name == 'super_admin')) {
                            this.router.navigate(['/dashboard']);
                            return false;
                        } else {
                            return true;        
                        }
                    }
                }
            } else {
                return true;
            }

        } else {
            this.globalEventMangerService.showNavBar(false);
            this.router.navigate(['/login']);
            return false;
        }

    }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/auth-guard.ts